module.exports = __webpack_public_path__ + "img/r6c2.576d7072.jpg";